import { useMemo } from 'react'
import _ from 'lodash'

import { filterToursByField } from '../utilities/filters/filterToursByField'

export function useFilterTours(tours, filterState) {
  return useMemo(() => {
    const exactMatchFilters = _.get(filterState, 'matchExactly', [])
    const filterableFields = _.keys(_.omit(filterState, ['matchExactly']))

    let filteredTours = tours
    _.forEach(filterableFields, key => {
      const exactMatch = _.includes(exactMatchFilters, key)
      filteredTours = filterToursByField(filteredTours, key, filterState[key], exactMatch)
    })
  
    return filteredTours
  }, [tours, filterState])
}
